<template>
    <div 
      :style="styleObject"
      :class="{play: play, hidetext: !play}" 
      class="anim-txt">
        <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#ffffff'
    },
    bgHeight: {
      type: String,
      default: '90'
    },
    delay: {
      type: String,
      default: '0'
    },
    duration: {
      type: String,
      default: '0.5'
    },
    play: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleObject() {
      return {
        background: `linear-gradient(to right, ${
          this.color
        } 50%, transparent 50%) no-repeat top`,
        'background-size': `200% ${this.bgHeight}%`,
        'transition-duration': this.duration + 's',
        'transition-delay': this.delay + 's'
      };
    }
  }
};
</script>

<style lang="scss" src="./AnimText.scss">
</style>
